/**
 * Checks if the workplace type is "Home Healthcare" or "Hospice".
 * These workplace types have a reduced UI in the Workplace Profile Modal.
 */
export function isHomeHealthOrHospiceWorkplace(type: string | undefined): boolean {
  return type === "Home Healthcare" || type === "Hospice";
}

// cspell:ignore PLLC
const BUSINESS_SUFFIX_PATTERN =
  /[,\s-]+(LLC|L\.L\.C\.|Inc\.?|Incorporated|Corp\.?|Corporation|Co\.?|Company|Ltd\.?|Limited|LP|L\.P\.|LLP|L\.L\.P\.|PLLC|P\.L\.L\.C\.|PC|P\.C\.|DBA|d\/b\/a)\s*$/i;

const UPPERCASE_INITIALISM_PATTERN = /^[A-Z]{1,3}$/;

const COMMON_WORDS = new Set(["AND", "FOR", "THE", "OF", "IN", "AT", "OR", "TO", "BY"]);

export function normalizeAgencyName(name: string): string {
  if (!name.trim()) {
    return name;
  }

  const stripped = name.replace(BUSINESS_SUFFIX_PATTERN, "").trim();
  const words = stripped.split(/\s+/);

  return words
    .map((word, index) => {
      const isCommonWord = COMMON_WORDS.has(word.toUpperCase());

      if (isCommonWord && index > 0) {
        return word.toLowerCase();
      }

      if (UPPERCASE_INITIALISM_PATTERN.test(word) && !isCommonWord) {
        return word;
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
